import { render } from "./SingleTtrRegistryOdnostoron.vue?vue&type=template&id=3863b393&scoped=true"
import script from "./SingleTtrRegistryOdnostoron.vue?vue&type=script&lang=js"
export * from "./SingleTtrRegistryOdnostoron.vue?vue&type=script&lang=js"

import "./SingleTtrRegistryOdnostoron.vue?vue&type=style&index=0&id=3863b393&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3863b393"]])

export default __exports__